module.exports = __webpack_public_path__ + "img/Statistics.a8931445.svg";